// packages/core/number/src/number.ts
function clamp(value, _ref) {
  let [min, max] = _ref;
  return Math.min(max, Math.max(min, value));
}
export { clamp };